import { render } from "./PaneLineFraction.vue?vue&type=template&id=0bbe58c0&scoped=true&ts=true"
import script from "./PaneLineFraction.vue?vue&type=script&lang=ts"
export * from "./PaneLineFraction.vue?vue&type=script&lang=ts"

import "./PaneLineFraction.vue?vue&type=style&index=0&id=0bbe58c0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bbe58c0"]])

export default __exports__